import { queryOptions } from '@tanstack/react-query';

import { type ChallengeConfigsApi } from '../../challenge-configs-api.ts';
import { type CoursesApi } from '../../courses-api.ts';
import { fetchAllPages } from './fetch-all-pages.ts';

const COURSES_PAGE_SIZE = 25;

const DICTIONARY_CACHE_OPTIONS = {
  staleTime: Infinity,
  gcTime: Infinity,
  refetchInterval: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const;

export const coursesDictionaryQueryOptions = (coursesApi: CoursesApi, regionId?: number) =>
  queryOptions({
    queryKey: ['coursesDictionary', regionId ?? 'all'],
    queryFn: async () => {
      const pages = await fetchAllPages(
        (page) =>
          coursesApi.getCourses({ page, page_size: COURSES_PAGE_SIZE, region_id: regionId }),
        (lastPage) => Boolean(lastPage.next)
      );
      return pages.flatMap((page) => page.results);
    },
    ...DICTIONARY_CACHE_OPTIONS,
  });

export const challengeConfigsDictionaryQueryOptions = (challengeConfigsApi: ChallengeConfigsApi) =>
  queryOptions({
    queryKey: ['challengeConfigsDictionary'],
    queryFn: () => challengeConfigsApi.getChallengeConfigs({}),
    ...DICTIONARY_CACHE_OPTIONS,
  });
